module.exports = __webpack_public_path__ + "static/media/cq_sinistri.bd3438ae.svg";